/**
 * For Guide FAQ Accordion
 */
var guideFaqJs = (function () {
  var faqToggle = document.getElementsByClassName('single-tmp-faq__accordion');
  function init() {
    if (faqToggle.length > 0) {
      uiBindings();
    }
  }

  var uiBindings = function () {
    /**
     * Apply FAQ inside Links tabIndex -1 except first element
     */
    var allFAQLinks = document.querySelectorAll('.single-tmp-faq a'),
      firstELementLink = faqToggle[0].querySelectorAll('a');
    for (var j = 0; j < allFAQLinks.length; j++) {
      allFAQLinks[j].tabIndex = -1;
    }

    for (var k = 0; k < firstELementLink.length; k++) {
      firstELementLink[k].tabIndex = 0;
    }

    /**
     * Making First Element Active bydefault
     */

    for (var i = 0; i < faqToggle.length; i++) {
      faqToggle[i].setAttribute('data-index', i);
      faqToggle[i].children[0].querySelector('button').addEventListener('click', faqToggleClick);
    }

    //arrow up and down
    document.querySelector('.single-tmp-faq').addEventListener('keydown', function (event) {
      var accordion = document.querySelector('.single-tmp-faq');
      var target = event.target;
      var key = event.which.toString();
      var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.single-tmp-faq__question-btn'));

      // 33 = Page Up, 34 = Page Down
      var ctrlModifier = event.ctrlKey && key.match(/33|34/);

      // Is this coming from an accordion header?
      if (target.classList.contains('single-tmp-faq__question-btn')) {
        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          var index = triggers.indexOf(target);
          var direction = key.match(/34|40/) ? 1 : -1;
          var length = triggers.length;
          var newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        } else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
            // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
            // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
          }
          event.preventDefault();
        }
      }
    });

    function faqToggleClick() {
      var dataIndex = this.parentNode.parentNode.getAttribute('data-index'),
        faqAnswer = this.parentNode.parentNode.children[1],
        allFAQLinks = document.querySelectorAll('.single-tmp-faq a'),
        activeElementLink = this.parentNode.parentNode.querySelectorAll('a');

      //tabindex -1 assign to inside all FAQ accordion
      for (var j = 0; j < allFAQLinks.length; j++) {
        allFAQLinks[j].tabIndex = -1;
      }

      for (j = 0; j < faqToggle.length; j++) {
        if (j != dataIndex) {
          faqToggle[j].classList.remove('activeToggle');
          faqToggle[j].children[0].classList.remove('active');
          faqToggle[j].children[1].style.maxHeight = 0;
          faqToggle[j].children[0].querySelector("button").setAttribute('aria-expanded', false);
        } else {
          /**
           * Adding active class to the clicked element.
           */
          var isExpanded = (this.getAttribute('aria-expanded') === 'true');

          this.parentNode.parentNode.classList.toggle('activeToggle');
          this.parentNode.parentNode.classList.add('active-click');
          this.parentNode.parentNode.children[0].classList.toggle('active');
          this.setAttribute('aria-expanded', !isExpanded);

          for (var k = 0; k < activeElementLink.length; k++) {
            if (this.parentNode.parentNode.classList.contains('activeToggle')) {
              activeElementLink[k].tabIndex = 0;
            } else {
              activeElementLink[k].tabIndex = -1;
            }
          }

          /**
           * Adding height to the Faq Answer
           */
          if (!this.parentNode.parentNode.classList.contains('activeToggle')) {
            faqAnswer.style.maxHeight = null;
          } else {
            faqAnswer.style.maxHeight = faqAnswer.scrollHeight + 'px';
          }
        }
      }

      //show images from lazy load
      lazyLoading.show();
    }
  };
  init();
})();
